import { RawStudyMetaConfigV1, RawStudyMetaConfigV1Schema } from '@csp/config-schemas';
import { JsonValidationService } from '@csp/csp-common-util';
import { StudyConfigUnifyVersion, StudyMetaConfig } from '@csp/csp-common-model';

const validateStudyMetaConfig = (config: RawStudyMetaConfigV1): StudyMetaConfig | undefined => {
  JsonValidationService.validateJsonNonStrict('StudyMeta config V1', RawStudyMetaConfigV1Schema, config);

  try {
    const onboardedStudyVersion: StudyConfigUnifyVersion = config.onboardedStudyVersion as StudyConfigUnifyVersion;
    const baselineStudyVersion: StudyConfigUnifyVersion = config.baselineStudyVersion as StudyConfigUnifyVersion;
    return {
      onboardedStudyVersion,
      baselineStudyVersion,
    };
  } catch (e) {
    throw new TypeError(
      `Invalid studyMetaConfig. onboardedStudyVersion: ${config.onboardedStudyVersion}, baselineStudyVersion: ${config.baselineStudyVersion}"`,
    );
  }
};

export const StudyMetaValidationService = {
  validateStudyMetaConfig,
};
